<template>
  <div style="background-image: linear-gradient(390deg, #68C949 25%, #0098FF 65%)" class="vh-100">
      <div id="marketing-updates" 
        class="carousel slide vh-100"
        :class="{'flex-column d-flex justify-content-center': !$breakpoint.smAndDown}"
        data-ride="carousel">
          <div class="carousel-inner text-white w-75 mx-auto">
              <div class="carousel-item active text-center">
                <div :class="{'d-flex flex-column': $breakpoint.smAndDown}">
                  <img :src="img2" 
                    :class=" $breakpoint.smAndDown ? 'img2 d-block mw-100 mx-auto order-1 mt-3 ' : 'carousel-img2 d-block mw-100 mx-auto' "
                    alt="marketing message">
                  <div :class="{'order-0': $breakpoint.smAndDown}">
                    <h2 :class=" $breakpoint.smAndDown ? 'h1 font-weight-bold text-shadow marketing-text-color' : 'h1 font-weight-bold text-shadow my-3 marketing-text-color' " >    
                        Your Market’s Gone Mobile!
                    </h2>
                    <p class="h3 marketing-text-color"> We don’t want you to miss out. Full availability of offers and prices on the go. </p>
                    <a href="https://www.onlinefuels.com/distributors/onlinefuels-mobile-enhanced/?utm_source=login-page&utm_medium=login-screen&utm_campaign=mobile" 
                       target="_blank" 
                      :class=" $breakpoint.smAndDown ? 'learn-more-1 btn carousel-btn-colors' : 'carousel-learn-more-1 btn carousel-btn-colors' ">
                       Learn more
                    </a>
                  </div>
                </div>
              </div>
              <div class="carousel-item text-center">
                <div :class="{'d-flex flex-column': $breakpoint.smAndDown}">
                  <img :src="img1"
                    :class=" $breakpoint.smAndDown ? 'img1 d-block mw-100 mx-auto order-1 mt-3 ' : 'carousel-img1 d-block mw-100 mx-auto' "
                    alt="marketing message">
                  <div :class="{'order-0': $breakpoint.smAndDown}">
                    <h2 :class="$breakpoint.smAndDown ? 'h1 font-weight-bold text-shadow marketing-text-color' : 'h1 font-weight-bold text-shadow my-4 marketing-text-color' " >
                        Everything you can do on your desktop.
                    </h2>
                    <p :class="$breakpoint.smAndDown ? 'h3' : 'h3 mb-3' " class="marketing-text-color">
                       Full functionality and simplicity, just on a smaller screen.</p>
                    <a href="https://www.onlinefuels.com/distributors/onlinefuels-mobile-enhanced/?utm_source=login-page&utm_medium=login-screen&utm_campaign=mobile" 
                       target="_blank"
                      :class=" $breakpoint.smAndDown ? 'learn-more-2 btn carousel-btn-colors' : 'carousel-learn-more-2 btn carousel-btn-colors' ">
                       Learn more
                    </a>
                  </div>
                </div>
              </div>
          </div>
          <a class="carousel-control-prev" href="#marketing-updates" role="button" data-slide="prev">
              <i class="fas fa-chevron-circle-left fa-2x" aria-hidden="true"></i>
              <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#marketing-updates" role="button" data-slide="next">
              <i class="fas fa-chevron-circle-right fa-2x" aria-hidden="true"></i>
              <span class="sr-only">Next</span>
          </a>
          <ol class="carousel-indicators">
              <li data-target="#marketing-updates" data-slide-to="0" class="active"></li>
              <li data-target="#marketing-updates" data-slide-to="1"></li>
          </ol>
          <ul class="carousel-socials">
            <li>
              <a href="https://twitter.com/onlinefuels" target="_blank"><i class="fab fa-twitter-square carousel-social-colors fa-2x"></i></a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/onlinefuels" target="_blank"><i class="fab fa-linkedin carousel-social-colors fa-2x"></i></a>
            </li>
            <li>
              <a href="https://www.facebook.com/OnlineFuels/" target="_blank"><i class="fab fa-facebook-square carousel-social-colors fa-2x"></i></a>
            </li>
          </ul>
      </div>
  </div>
</template>


<script>
import breakpoint from '@/mixins/index';
const campaignImage1 = require('../../assets/images/campaignImage1.png')
const campaignImage2 = require('../../assets/images/campaignImage2.png')

export default {
  mixins: [breakpoint],
  data() {
    return{
        img1: campaignImage1,
        img2: campaignImage2,
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_carousel.scss";

// MOBILE STYLING
.learn-more-1 {
  margin-top: 1rem;
}
.learn-more-2 {
  margin-top: 2.7rem;
}
.img1 {
  width: 240px;
}
.img2 {
  width: 240px;
}


</style>